export default __webpack_public_path__ + "static/media/main_features_1.91c42ba9.webp";